import {AnyReceiveMethodName, VKBridgeEvent} from '@vkontakte/vk-bridge';
import {useCallback, useEffect} from 'react';
import {bridge} from 'utils/bridge';

export const useSetBarColor = () => {
    const setBarColor = useCallback(() => {
        bridge &&
            bridge
                .sendWithCatch('VKWebAppSetViewSettings', {
                    status_bar_style: 'light',
                    action_bar_color: '#141414',
                    navigation_bar_color: '#141414',
                })
                .catch(() => {});
    }, []);

    useEffect(() => {
        setBarColor();
    }, [setBarColor]);

    const onBridgeEvent = useCallback(
        ({detail: {type}}: VKBridgeEvent<AnyReceiveMethodName>) => {
            if (type === 'VKWebAppViewRestore') {
                setBarColor();
            }
        },
        [setBarColor],
    );

    useEffect(() => {
        bridge && bridge.subscribe(onBridgeEvent);
        return () => {
            bridge && bridge.unsubscribe(onBridgeEvent);
        };
    }, [onBridgeEvent]);
};
